/**
 * Model to handle roles
 */
define('dataSource/oemMessages',['jquery', 'atn/atn', 'lodash','dataSource/uiVersion','common/utils'],
    function($, atn, _, uiVersion, utils) {
        'use strict';

        var rebrandingResourceFolder = atn.config.oemRebrandingFolder;
        var rebrandingResourceObj = atn.config.oemResourcesMap;
        var oemMessages = {};

        return {
            getOemMessageStrings: getOemMessageStrings,
            oemMessages: oemMessages
        };

        /**
         * fetches the roles into roles
         * @return {promise} promise object for fetching roles
         */
        function getOemMessageStrings() {
            var promise = $.get( rebrandingResourceFolder + 
                rebrandingResourceObj.MESSAGES + '?id=' + uiVersion.uiVersion.id),
                deferred = $.Deferred();
            promise.done(function(response) {
                _.assign(oemMessages, response);
                _.defer(deferred.resolve, oemMessages);
            }).fail(function() {
                utils.cleanupObject(oemMessages);
                _.defer(deferred.reject, oemMessages);
            });
            return deferred.promise();
        }
    });
